import { all } from 'redux-saga/effects';

import accountSaga from 'features/Account/accountSaga';
import clientsSaga from 'sagas/clientsSaga';
import deviceSaga from 'sagas/deviceSaga';
import loginSaga from 'components/layouts/login/saga';
import profileSaga from 'features/Settings/profile/store/sagas';
import testFormSaga from '../../sagas/test-form-saga';
import testsSaga from 'sagas/testsSaga';
import usersSaga from 'sagas/usersSaga';
import signupSaga from '../../features/Signup/duck/signup-saga';

export default function* rootSaga() {
  yield all([
    accountSaga(),
    clientsSaga(),
    deviceSaga(),
    loginSaga(),
    profileSaga(),
    signupSaga(),
    testFormSaga(),
    testsSaga(),
    usersSaga(),
  ]);
}



// WEBPACK FOOTER //
// ./src/core/sagas/index.js